/**
 * React Query: 네트워크 fetch 없이 캐시·initialData만 사용.
 * RQ 5.101 NetworkMode는 'online' | 'always' | 'offlineFirst'만 지원('offline' 없음).
 * enabled:false로 fetch를 막고, RQ persist / LS initialData만 읽는다.
 */
export function cacheOnlyQueryOptions(cacheOnly: boolean | undefined) {
  if (!cacheOnly) return {};
  return {
    enabled: false as const,
    refetchOnMount: false as const,
    refetchOnReconnect: false as const,
    refetchOnWindowFocus: false as const,
    retry: false as const,
  };
}
